import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { History } from '../../_model/history-response/history';
import { HistoryResponse } from '../../_model/history-response/history-response';
import { TableResponse } from '../../_model/table-response/table-response';
import { Constants } from '../../_model/constants';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule  } from '@angular/material/card';
@Component({
  selector: 'app-work-order-history-dialog',
  templateUrl: './work-order-history-dialog.component.html',
  standalone: true,
  imports: [MatTableModule, MatDialogModule, MatInputModule, MatSelectModule, MatButtonModule, MatCardModule],
  styleUrls: ['./work-order-history-dialog.component.scss']
})
export class WorkOrderHistoryDialogComponent implements OnInit {

  public history!: TableResponse;
  public item: any;
  tableData!: TableResponse;
  tableDisplayedColumns!: string[];
  constructor(public datepipe: DatePipe, public matDialogRef: MatDialogRef<WorkOrderHistoryDialogComponent, History>,
    @Inject(MAT_DIALOG_DATA) public data: { history: TableResponse; trigger: ElementRef; item: any }) { }

  ngOnInit() {
    this.history = this.data.history;
    this.item = this.data.item;
    if(this.history){
      let i : any;
      this.history.data.tableRows.forEach((i)=> {
          if(environment.locale == "en-GB"){
            const dateObject = new Date(i.statusDate);
            i.statusDate = this.formatUTCENGBDate(dateObject); // Use the custom function
            // i.statusDate = this.datepipe.transform( i.statusDate, Constants.dateFormatEngbHistory);
          }
           else if(environment.locale == "en-US"){
            const dateObject = new Date(i.statusDate);
            i.statusDate = this.formatUTCUSDate(dateObject); // Use the custom function    
            // i.statusDate = this.datepipe.transform( i.statusDate, Constants.dateFormaten029History);
           }
      })
    }
     this.tableDisplayedColumns = this.history.data.tableDefinitions.map(
          (c) => c.columnDef
        );
    const rect = this.data.trigger.nativeElement.getBoundingClientRect();
  }
  formatUTCUSDate(date: Date): string {
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    return `${month}-${day}-${year} ${hours}:${minutes}`;
  }

  formatUTCENGBDate(date: Date): string {
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const day = date.getUTCDate().toString().padStart(2, '0');
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  
    return `${day}-${month}-${year} ${hours}:${minutes}`; // Changed order to dd-MM
  }
}
